export const cabinClassEnum = {
    apiKeys: {
        Economy: "Economy",
        PremiumEconomy: "PremiumEconomy",
        Business: "Business",
    },
    displayNames: {
        Economy: "Economy Class",
        PremiumEconomy: "Premium Comfort",
        Business: "Business Class",
    },
    cssClasses: {
        Base: "cabin-class-label",
        Economy: "economy-class",
        PremiumEconomy: "premium-economy-class",
        Business: "business-class",
        Multi: "multi-class",
    }
};
